import React from 'react';
import ChatPreviewItem from './ChatPreviewItem';
import { Chat } from '../types/Chat';

interface ChatSidebarProps {
  chats: Chat[];
  handleShowChat: () => void;
  mapChatToPreview?: (chat: Chat) => {
    name: string;
    uuid: string;
    avatar: string;
  };
  fallbackPreviewText?: string;
  showPrivacyNotice?: boolean;
}

const ChatSidebar: React.FC<ChatSidebarProps> = (props) => {
  const mapChatToPreview =
    props.mapChatToPreview ||
    ((chat: Chat) => ({
      name: chat.host_name,
      uuid: chat.host_uuid,
      avatar: chat.host_avatar,
    }));

  return (
    <div className="chat-sidebar lg:w-[20rem] w-full">
      <div className='flex-col flex justify-between h-full'>
        <div className='flex flex-col'>
          <h1 className='text-xl font-bold mb-0 p-6'>Messaggi</h1>
          <div className='flex-col flex'>
            {props.chats?.map((chat) => {
              const preview = mapChatToPreview(chat);
              return (
                <ChatPreviewItem
                  host_name={preview.name}
                  host_uuid={preview.uuid}
                  host_avatar={preview.avatar}
                  chat_uuid={chat.chat_uuid}
                  key={chat.chat_uuid}
                  handleShowChat={props.handleShowChat}
                  previewText={chat.previewContent}
                  fallbackPreviewText={props.fallbackPreviewText}
                  onClick={() => null}
                />
              );
            })}
          </div>
        </div>
        {props.showPrivacyNotice !== false && (
          <div className='flex justify-center bg-gray-100'>
            <span className='p-6'>
              I messaggi scambiati tra host e utente sono visualizzabili esclusivamente tra le due parti e il team di moderazione di TribYou
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatSidebar;
